import { createContext } from "react";

type NavEventName = "nav/sidebar-item-clicked" | "nav/tab-reordered";

export type TrackNavEvent = (
  name: NavEventName,
  properties: Record<string, unknown>,
) => void;

/** Reports nav interactions to the host app's analytics. Silent by default. */
export const NavEventTrackerContext = createContext<TrackNavEvent>(() => {});
